import React, { Component } from "react";
import EatWithMeText from "../../components/EatWIthMeText";
import MenuItemHeader from "../../components/MenuItemHeader";
import UserImageButton from "../../components/icon-buttons/UserImageButton";
import ChangeLanguage from "../../components/icon-buttons/ChangeLanguage";
import { Button } from "react-bootstrap";
import { auth, get } from "../../js/auth";

class PrinterServerBrowser extends Component {
  legacyContainerRef = React.createRef();
  iframeRef = React.createRef();
  injectToken = 0;

  state = {
    loading: false,
    servers: [],
    selectedServer: "",
    error: "",
    localUiVisible: false
  };

  componentDidMount() {
    window.addEventListener("message", this.handleFrameMessage);
    this.syncFromRoute();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevRouteServer = prevProps.match?.params?.printerServer;
    const nextRouteServer = this.props.match?.params?.printerServer;
    const prevHashServer = this.getSelectedServerFromHash(prevProps.location || window.location);
    const nextHashServer = this.getSelectedServerFromHash(this.props.location || window.location);

    if (prevRouteServer !== nextRouteServer || prevHashServer !== nextHashServer) {
      this.syncFromRoute();
    }

    // Refs are attached before componentDidUpdate runs, so the iframe exists here.
    if (
      this.state.localUiVisible &&
      this.state.selectedServer &&
      (!prevState.localUiVisible || prevState.selectedServer !== this.state.selectedServer)
    ) {
      this.injectPrinterServerUi(this.state.selectedServer);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleFrameMessage);
    this.cleanupLegacyUi();
  }

  // The printer UI cannot use location.reload() inside the srcdoc iframe, so it asks us to re-inject itself.
  handleFrameMessage = event => {
    const iframe = this.iframeRef.current;
    if (!iframe || event.source !== iframe.contentWindow) {
      return;
    }
    if (event.data && event.data.type === "printerServerReload" && this.state.selectedServer) {
      this.injectPrinterServerUi(this.state.selectedServer);
    }
  };

  syncFromRoute = () => {
    const rawRouteServer = this.props.match?.params?.printerServer;
    const hashServer = this.getSelectedServerFromHash(this.props.location || window.location);
    const serverFromRoute = rawRouteServer && rawRouteServer !== "printerServerBrowser"
      ? rawRouteServer
      : hashServer && hashServer !== "printerServerBrowser"
        ? hashServer
        : "";

    if (serverFromRoute) {
      this.setState({
        selectedServer: serverFromRoute,
        localUiVisible: true
      });
      return;
    }

    this.cleanupLegacyUi();
    this.setState(prevState => (prevState.localUiVisible || prevState.selectedServer ? { localUiVisible: false, error: "" } : null), () => this.loadServers());
  };

  cleanupLegacyUi = () => {
    this.injectToken++;

    // Never clear the container's innerHTML: the iframe is its React-managed child.
    const iframe = this.iframeRef.current;
    if (iframe) {
      iframe.onload = null;
      iframe.onerror = null;
      iframe.removeAttribute("srcdoc");
      iframe.src = "about:blank";
    }

    if (typeof window !== "undefined") {
      window.settings = null;
      if (typeof window.stopStatusPollLoop === "function") {
        window.stopStatusPollLoop();
      }
      if (typeof window.stopSSEReconnectLoop === "function") {
        window.stopSSEReconnectLoop();
      }
      if (window.statusEventSource) {
        window.statusEventSource.close();
        window.statusEventSource = null;
      }
      if (window.eventSource) {
        window.eventSource.close();
        window.eventSource = null;
      }
      if (document && document.head) {
        Array.from(document.head.querySelectorAll("base[data-printer-relay='true'], script[data-printer-relay='true'], style[data-printer-relay='true'], link[data-printer-relay='true']")).forEach(node => {
          if (node && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
      }
      delete window.__printerServerRelayBase;
      delete window.appServer;
    }
  };

  getSelectedServerFromHash = location => {
    const targetLocation = location || window.location;
    const hash = targetLocation.hash || "";
    const normalized = (hash.startsWith("#") ? hash.substring(1) : hash)
      .replace(/^\/+/, "")
      .replace(/\/+$/, "");
    const parts = normalized.split("/").filter(Boolean);
    if (!parts.length) return "";

    const reservedIndex = parts.lastIndexOf("printerServerBrowser");
    if (reservedIndex >= 0) {
      const candidate = parts[reservedIndex + 1];
      if (candidate && !candidate.startsWith("?")) {
        return decodeURIComponent(candidate);
      }
      return "";
    }

    const server = parts[parts.length - 1];
    return server && !server.startsWith("?") ? decodeURIComponent(server) : "";
  };

  updateHashForServer = selectedServer => {
    const pageRoute = "#/superAdminMenus/printerServerBrowser";
    const nextHash = selectedServer ? `${pageRoute}/${encodeURIComponent(selectedServer)}` : pageRoute;
    if (nextHash !== window.location.hash) {
      window.history.replaceState(null, "", nextHash);
    }
  };

  handleServerChange = event => {
    const selectedServer = event.target.value;
    this.setState({ selectedServer });
  };

  returnToSelection = () => {
    this.cleanupLegacyUi();
    this.updateHashForServer("");
    this.setState({ localUiVisible: false, selectedServer: "", error: "" }, () => this.loadServers());
  };

  loadServers = () => {
    this.setState({ loading: true, error: "" });
    get("printerServerClient/connectedPrinterServers", undefined, undefined, 15000, false, true, false, "json")
      .done(data => {
        const servers = Array.isArray(data) ? data : [];
        const selectedFromHash = this.getSelectedServerFromHash();
        const hashRouteServer = selectedFromHash && selectedFromHash !== "printerServerBrowser" ? selectedFromHash : "";

        if (hashRouteServer) {
          this.setState(
            {
              loading: false,
              servers,
              selectedServer: hashRouteServer,
              error: "",
              localUiVisible: true
            }
          );
          return;
        }

        const selectedServer = servers.length > 0 ? servers[0] : "";

        this.setState(
          {
            loading: false,
            servers,
            selectedServer,
            error: servers.length ? "" : "No connected printer servers",
            localUiVisible: false
          },
          () => {
            const canonicalHash = "#/superAdminMenus/printerServerBrowser";
            if (window.location.hash !== canonicalHash) {
              window.history.replaceState(null, "", canonicalHash);
            }
          }
        );
      })
      .fail(() => {
        this.setState({
          loading: false,
          servers: [],
          selectedServer: "",
          error: "Unable to load connected printer servers"
        });
      });
  };

  buildRelayUrl = selectedServer => {
    if (!selectedServer) {
      return "";
    }

    // Same base that get()/post() use for every other API call: auth.server + "/eatwithme.server/".
    const apiBase = ((auth && auth.server) || window.location.origin || "").replace(/\/+$/, "");
    return `${apiBase}/${auth.war || "eatwithme.server"}/printerServerClient/browserProxy/${encodeURIComponent(selectedServer)}`;
  };

  patchHtmlForRelay = (html, relayBaseUrl) => {
    const normalizedBase = relayBaseUrl.replace(/\/+$/, "") + "/";
    const rewriteAssetUrl = value => {
      if (!value || value === "" || value.startsWith("#") || value.startsWith("data:") || value.startsWith("javascript:") || value.startsWith("mailto:") || /^(?:[a-z]+:)?\/\//i.test(value)) {
        return value;
      }

      const cleaned = value.trim().replace(/^['"]|['"]$/g, "").replace(/^\.\//, "").replace(/^\//, "");
      if (!cleaned) {
        return value;
      }

      try {
        return new URL(cleaned, normalizedBase).toString();
      } catch (error) {
        return `${normalizedBase}${cleaned}`;
      }
    };

    const withoutCspMeta = html
      .replace(/<meta\s+[^>]*http-equiv=["']Content-Security-Policy["'][^>]*>/gi, "")
      .replace(/<meta\s+[^>]*content-security-policy[^>]*>/gi, "");

    let rewritten = withoutCspMeta
      .replace(/appServer\s*=\s*location\.href\s*;/gi, "appServer = window.__printerServerRelayBase || location.href;")
      .replace(/new EventSource\(\s*(['"])(\/)?printerService\/status\1\s*\)/gi, "new EventSource(window.__printerServerRelayBase + 'printerService/status')")
      .replace(/new EventSource\(\s*(['"])(\/)?printerService\/status\?[^'"]*\1\s*\)/gi, "new EventSource(window.__printerServerRelayBase + 'printerService/status' + window.location.search)");

    rewritten = rewritten.replace(/(src|href)=(['"])([^'\"]+)(\2)/gi, (match, attr, quote, url) => {
      const rewrittenUrl = rewriteAssetUrl(url);
      return rewrittenUrl === url ? match : `${attr}=${quote}${rewrittenUrl}${quote}`;
    });

    const baseTag = `<base href="${normalizedBase}" data-printer-relay="true">`;
    const relayRuntimePatch = `
      <script data-printer-relay="true">
        (function() {
          var relayBase = ${JSON.stringify(normalizedBase)};
          window.__printerServerRelayBase = relayBase;
          window.appServer = relayBase;
          window.addEventListener('load', () => { onDeviceReady(); });
          function rewriteRelativeUrl(url) {
            if (typeof url !== 'string') {
              return url;
            }
            if (url === '' || url.startsWith('#') || url.startsWith('data:') || url.startsWith('javascript:') || url.startsWith('mailto:') || url.indexOf('://') >= 0) {
              return url;
            }
            var trimmedRelay = relayBase;
            while (trimmedRelay.endsWith('/')) {
              trimmedRelay = trimmedRelay.slice(0, -1);
            }
            while (url.startsWith('/')) {
              url = url.slice(1);
            }
            return trimmedRelay + '/' + url;
          }

          if (typeof window.EventSource !== 'undefined') {
            var NativeEventSource = window.EventSource;
            window.EventSource = function(url, options) {
              var normalizedOptions = options || {};
              normalizedOptions.withCredentials = true;
              return new NativeEventSource(rewriteRelativeUrl(url), normalizedOptions);
            };
            window.EventSource.CONNECTING = NativeEventSource.CONNECTING;
            window.EventSource.OPEN = NativeEventSource.OPEN;
            window.EventSource.CLOSED = NativeEventSource.CLOSED;
            window.EventSource.prototype = NativeEventSource.prototype;
          }

          if (window.XMLHttpRequest && window.XMLHttpRequest.prototype && window.XMLHttpRequest.prototype.open) {
            var originalOpen = window.XMLHttpRequest.prototype.open;
            window.XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
              if (this && typeof this.withCredentials !== 'undefined') {
                this.withCredentials = true;
              }
              return originalOpen.call(this, method, rewriteRelativeUrl(url), async, user, password);
            };
          }
            
        })();
      </script>`;
    if (/<head[^>]*>/i.test(rewritten)) {
      rewritten = rewritten.replace(/<head[^>]*>/i, match => `${match}\n${relayRuntimePatch}\n${baseTag}`);
    } else {
      rewritten = `${relayRuntimePatch}\n${baseTag}\n${rewritten}`;
    }

    const authScriptMatch = /<script[^>]*src=["'][^"']*js\/auth\.js[^"']*["'][^>]*><\/script>/i;
    if (authScriptMatch.test(rewritten)) {
      rewritten = rewritten.replace(authScriptMatch, match => `${relayRuntimePatch}\n${match}`);
    }

    if (/<base\s+href=/i.test(rewritten)) {
      return rewritten.replace(/<base\s+href=[^>]*>/i, `${baseTag}\n${relayRuntimePatch}`);
    }
    return rewritten;
  };

  injectPrinterServerUi = async selectedServer => {
    if (!selectedServer) {
      return;
    }

    const relayUrl = this.buildRelayUrl(selectedServer);
    if (!relayUrl) {
      return;
    }

    const iframe = this.iframeRef.current;
    if (!iframe) {
      return;
    }

    const token = ++this.injectToken;

    try {
      this.setState({ error: "", loading: true });

      const response = await fetch(relayUrl, {
        credentials: "include",
        headers: { Accept: "text/html" }
      });
      if (!response.ok) {
        throw new Error(`Proxy returned ${response.status}`);
      }

      const html = await response.text();
      if (token !== this.injectToken || this.iframeRef.current !== iframe) {
        return;
      }
      const patchedHtml = this.patchHtmlForRelay(html, relayUrl);

      iframe.onload = () => {
        this.setState({ loading: false });
      };
      iframe.srcdoc = patchedHtml;
    } catch (ex) {
      if (token !== this.injectToken) {
        return;
      }
      this.setState({
        loading: false,
        error: `Unable to load printer server UI (${ex.message || "unknown error"})`,
        localUiVisible: false
      });
    }
  };

  launchLocalUi = newTab => {
    const { selectedServer } = this.state;

    if (!selectedServer) {
      this.setState({ error: "Please select a printer server" });
      return;
    }

    this.updateHashForServer(selectedServer);
    if (newTab) {
      const nextHash = `#/superAdminMenus/printerServerBrowser/${encodeURIComponent(selectedServer)}`;
      window.open(nextHash, "_blank", "noopener,noreferrer");
      return;
    }
    this.setState({ localUiVisible: true });
  };

  render() {
    const { admin_local } = this.props;
    const {
      loading,
      servers,
      selectedServer,
      error,
      localUiVisible
    } = this.state;

    return (
      <div style={{ display: "flex", flexFlow: "column", flexGrow: 1, minHeight: 0 }}>
        <div
          className="menuItemHeader"
          style={{
            flexShrink: 0,
            display: "flex",
            flexFlow: "row",
            width: "100%",
            alignItems: "center",
            height: "50px",
            justifyContent: "space-between",
            paddingRight: "30px"
          }}
        >
          <EatWithMeText />
          <MenuItemHeader
            {...this.props}
            header={(admin_local && admin_local.menus && admin_local.menus.printer_server_browser) || "Printer server browser"}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <ChangeLanguage />
            <UserImageButton />
          </div>
        </div>

        <div style={{ padding: "12px 16px", display: "flex", flexFlow: "column", gap: "10px", minHeight: 0, flexGrow: 1 }}>
          {!localUiVisible ? (
            <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
              <select
                className="form-control"
                value={selectedServer}
                onChange={this.handleServerChange}
                style={{ maxWidth: "320px" }}
                disabled={loading || !servers.length}
              >
                {servers.length === 0 ? <option value="">No connected servers</option> : null}
                {servers.map(server => (
                  <option key={server} value={server}>
                    {server}
                  </option>
                ))}
              </select>
              <Button className="btn btn-primary" onClick={() => this.launchLocalUi(false)} disabled={loading || !selectedServer}>
                Open
              </Button>
              <Button className="btn btn-default" onClick={() => this.launchLocalUi(true)} disabled={loading || !selectedServer}>
                Open in new tab
              </Button>
              <Button className="btn btn-default" onClick={this.loadServers} disabled={loading}>
                Refresh
              </Button>
            </div>
          ) : null}

          {error ? <div className="text-danger">{error}</div> : null}

          {localUiVisible ? (
            <div style={{ display: "flex", flexFlow: "column", gap: "12px", background: "#fff", border: "1px solid #ddd", borderRadius: "8px", padding: "16px", flex: 1 }}>
              <div style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                <div>
                  <h4 style={{ margin: 0 }}>Printer server: {selectedServer || "Loading..."}</h4>
                  <p style={{ margin: 0, color: "#666" }}>
                    Local frontend shell for the selected printer server. Relay calls to the printer backend are kept separate from the browser UI.
                  </p>
                </div>
                <Button
                  className="btn btn-default"
                  onClick={this.returnToSelection}
                >
                  Back to selection
                </Button>
              </div>

              <div
                ref={this.legacyContainerRef}
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflow: "hidden",
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px"
                }}
              >
                <iframe
                  ref={this.iframeRef}
                  title="printer-server-browser"
                  style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "600px",
                    border: "0",
                    background: "#fff"
                  }}
                  sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default PrinterServerBrowser;
